import { render, staticRenderFns } from "./inputGoods.vue?vue&type=template&id=c5f0e368&scoped=true"
import script from "./inputGoods.vue?vue&type=script&lang=js"
export * from "./inputGoods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5f0e368",
  null
  
)

export default component.exports